var topBtn = $('#backToTop');

$(window).scroll(function() {
    if ($(window).scrollTop() > 800) {
        topBtn.addClass('is-visible');
    } else {
        topBtn.removeClass('is-visible');
    }
});

topBtn.on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({
        scrollTop: 0
    }, '300');
});